export function isStartMessage(message) {
  return (
    message['metadata'] &&
    message['metadata']['custom_info'] &&
    message['metadata']['custom_info']['template_name'] &&
    message['metadata']['custom_info']['template_name'].startsWith(
      'utter_start'
    )
  )
}

export function getCustomData(message) {
  return message['custom'] && message['custom']['data']
    ? message['custom']['data']
    : message['config'] && message['config']['data']
    ? message['config']['data']
    : message
}
